export function isUrlParamsEqual(first: URLSearchParams, second: URLSearchParams) {
  if (first.toString() === second.toString()) {
    return true;
  }

  for (const [key, value] of first.entries()) {
    if (!second.has(key) || second.get(key) !== value) {
      return false;
    }
  }

  for (const key of second.keys()) {
    if (!first.has(key)) {
      return false;
    }
  }

  return true;
}
